import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton"
import 'react-loading-skeleton/dist/skeleton.css'

const BoxSkeleton = (props) => {
    const items = Array.from({ length: props.count }, (_, index) => index + 1);

    return(<>
        <Row style={{width: props.containerWidth || '100%' }}>
            {items.map((item) => (
                <div key={item} className={`col-${props.size}`} style={{height:props.height,marginBottom:"7px"}}>
                    <Skeleton width="100%" height="100%"/>
                </div>
            ))}
        </Row>
    </>)
}

export default BoxSkeleton